import { defaultState, TenantDataAction, TenantDataState } from "../reducers/TenantData";
import React, { Component } from "react";
import { IStore } from "@my-dld/reducers/store";
import { connect } from "react-redux";
import { dispatchX } from "@my-dld/utils/StoreUtils";

export interface ITenantContext extends TenantDataState {

}

interface Props extends ITenantContext {

}

export const TenantContext = React.createContext( defaultState );

interface State {

}

class TenantContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const { children, ...props } = this.props;
		return <TenantContext.Provider value={ props }>
			{ children }
		</TenantContext.Provider>;
	}
}

const mapStateToProps = ( state: IStore, ownProps: Partial<ITenantContext> & { children?: any } ): ITenantContext => {
	return {
		...state.TenantData,
	};
};

export default connect( mapStateToProps )( TenantContextWrapper );

export function updateTenantContext( data: Partial<TenantDataState> ) {
	dispatchX( {
		type: TenantDataAction.TENANT_UPDATE_STATE,
		payload: {
			...data
		}
	} );
}

export function resetTenantContext() {
	dispatchX( {
		type: TenantDataAction.TENANT_CLEAR_DATA,
	} );
}
